import './style.scss';
const HeaderRoot = ({ children }) => {
  return (
    <header className="header">
      {children}
    </header>
  );
};

export default HeaderRoot;
